import * as React from 'react';
import './ManageCommentsPage.scss';
import { RouteComponentProps } from 'react-router';
import Landman from 'src/models/Landman';
import PerformanceComment from 'src/models/PerformanceComment';
import { IRootState } from 'src/reducers';
import selectors from 'src/selectors';
import actions from 'src/actions';
import { connect } from 'react-redux';
import CardContainer from '../../common/CardContainer';
import Button from '../../controls/forms/redesign/FormButton';
import { Card } from '@blueprintjs/core';
import UserDetails from 'src/models/UserDetails';
import EditCommentDialog from '../dialogs/EditCommentDialog';
import DialogList from 'src/dialogs';
import TitleCard from '../components/TitleCard';
import CommentList from '../components/CommentList';

interface IManageCommentsPageStateProps {
    landman: (id: number) => Landman;
    performanceComments: Array<PerformanceComment>;
    user: UserDetails;
}

export interface IManageCommentsPageDispatchProps {
    getLandman: (id: number) => void;
    getPerformanceComments: (userId: number) => void;
    updatePerformanceComment: (comment: PerformanceComment) => void;
    deletePerformanceComment: (comment: PerformanceComment) => void;
    setDialogShowing: (dialogName: string) => void;
}

type ManageCommentsPageState = {
    selectedComment: PerformanceComment;
};

type IManageCommentsPageProps = RouteComponentProps<{ id?: string }> & IManageCommentsPageStateProps & IManageCommentsPageDispatchProps;

class ManageCommentsPage extends React.Component<IManageCommentsPageProps, ManageCommentsPageState> {
    readonly state: Readonly<ManageCommentsPageState> = {
        selectedComment: undefined,
    };

    componentDidMount() {
        const landmanId = parseInt(this.props.match.params.id, 10);
        this.props.getLandman(landmanId);
        this.props.getPerformanceComments(landmanId);
    }

    onEditCommentClick = (comment: PerformanceComment) => {
        this.setState({ selectedComment: comment });
        this.props.setDialogShowing(DialogList.EDIT_COMMENT);
    };

    public render() {
        const landman = this.props.landman(parseInt(this.props.match.params.id, 10));
        return (
            <>
                <div>
                    <TitleCard name={'Performance Comments: ' + landman && landman.firstName + ' ' + landman.lastName} />
                    <CardContainer>
                        <Card>
                            <div>
                                <Button
                                    size="medium"
                                    intent="primary comment-button"
                                    text="Back to Landman Detail"
                                    onClick={() => this.props.history.goBack()}
                                />
                            </div>
                            <CommentList
                                performanceComments={this.props.performanceComments}
                                onEditCommentClick={this.onEditCommentClick}
                                updatePerformanceComment={this.props.updatePerformanceComment}
                                deletePerformanceComment={this.props.deletePerformanceComment}
                            />
                        </Card>
                    </CardContainer>
                </div>
                <EditCommentDialog
                    user={this.props.user}
                    updatePerformanceComment={this.props.updatePerformanceComment}
                    selectedComment={this.state.selectedComment}
                />
            </>
        );
    }
}

const mapStateToProps = (state: IRootState) => ({
    landman: (id: number) => selectors.landman.landman(id)(state),
    performanceComments: selectors.performanceComments.performanceComments(state),
    user: selectors.auth.user(state),
});

const mapDispatchToProps: IManageCommentsPageDispatchProps = {
    getLandman: (id: number) => actions.landman.getLandman(id),
    getPerformanceComments: (userId: number) => actions.performanceComment.getPerformanceComments(userId),
    updatePerformanceComment: (comment: PerformanceComment) => actions.performanceComment.updatePerformanceComment(comment),
    deletePerformanceComment: (comment: PerformanceComment) => actions.performanceComment.deletePerformanceComment(comment),
    setDialogShowing: (dialogName: string) => actions.layout.showDialog(dialogName),
};

export default connect(mapStateToProps, mapDispatchToProps)(ManageCommentsPage);



// WEBPACK FOOTER //
// ./src/components/personnel/pages/ManageCommentsPage.tsx